export type Job = {
  id: number; //JobListingId
  jobId: number;
  companyImageUrl?: string;
  companyName: string;
  countryCode: string;
  languageCode: string;
  description: string;
  title: string;
  jobImageUrl?: string;
  jobCategoryTranslateKey: string;
  jobPositionTranslateKey?: string;
  workTimePreferenceFullTime?: boolean;
  workTimePreferencePartTime?: boolean;
  workTimePreferenceSeasonal?: boolean;
  companyVerified: boolean;
  militaryRequirements?: MilitaryStatus[];
  location?: string;
  tags: string;
  status: JobStatus;
  lat?: number;
  lng?: number;
  interviewLocation?: string;
  languages: JobLanguage[];
  shifts: WorkShiftDaily[] | WorkShiftWeekly | undefined;
};

export enum JobStatus {
  ACTIVE = 'active',
  DELETED = 'deleted',
  CLOSED = 'closed',
}

export type JobLanguage = {
  languageName: string;
  languageCode: string;
  level: LanguageLevel;
};

export type WorkShiftDaily = {
  day: Days;
  endTime: string;
  startTime: string;
};

export type WorkShiftWeekly = {
  offTime: string;
  workStartAt: string;
  weeklyOffDayCount: number;
  dailyTotalWorkHour: number;
};

export enum Days {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export enum LanguageLevel {
  None = 1,
  Beginner = 2,
  Intermediate = 3,
  Advanced = 4,
}

export enum MilitaryStatus {
  WAITING = 1,
  DELAYED = 2,
  DONE = 3,
}
